export function addScript(doc, source, callback, errback) {
  var tag = doc.createElement('script')
  tag.type = 'text/javascript'
  tag.src = source
  tag.onload =
    callback ||
    function () {
      console.log('laoded ', source)
    }
  tag.onerror = errback
  doc.head.append(tag)
}
